const path = 'activities';

export default [
  {
    path: path,
    name: 'activities',
    component: () => import('@views/activities/Index.vue')
  }
]
